/* global axios */
import ApiClient from './ApiClient';

class GoogleCalendarAPI extends ApiClient {
  constructor() {
    super('google_calendar_connections', { accountScoped: true });
  }

  // kind: 'personal' | 'shared'
  generateAuthorization(kind) {
    return axios.post(`${this.url}/authorization`, { kind });
  }

  // Which calendars exist (drive pickers): { personal_mine, personal_any, shared }
  availability() {
    return axios.get(`${this.url}/availability`);
  }

  // Próximos horários livres. kind: 'personal'|'shared', duration em minutos.
  freeSlots({ kind = 'personal', duration = 30 } = {}) {
    return axios.get(`${this.url}/free_slots`, { params: { kind, duration } });
  }

  calendars(id) {
    return axios.get(`${this.url}/${id}/calendars`);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, {
      google_calendar_connection: payload,
    });
  }
}

export default new GoogleCalendarAPI();
